import React, { Fragment } from 'react'

import Typography from '@material-ui/core/Typography'

import sponsors from '../../assets/images/sponsors.png'

import { useThemedStyles } from '../hooks/useThemedStyles'

const styles = (theme) => ({
  sponsorsContainer: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('xs')]: {
      width: 320,
    },
  },
  sponsorsLogos: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
    },
  },
  sponsorLogo: {
    margin: theme.spacing(1),
    maxHeight: '96px',
    [theme.breakpoints.down('xs')]: {
      width: 300,
    },
  },
})

export default function Sponsors({ firstPage }) {
  const classes = useThemedStyles(styles)

  return (
    <Fragment>
      <div className={classes.sponsorsContainer}>
        {!firstPage && <Typography variant="body1">Realização</Typography>}

        <div className={classes.sponsorsLogos}>
          <img className={classes.sponsorLogo} alt="Logo" src={sponsors} />
        </div>
      </div>
    </Fragment>
  )
}
